import { useAuthMutation } from 'queries/query';
import { MeApi } from 'api';

function useChangePassword() {
  return useAuthMutation(MeApi.changePassword);
}

export default useChangePassword;
